




import { defineComponent } from '@vue/composition-api';

const Index = defineComponent({});

export default Index;
